<template>
  <div id="video_share">
    <!--openinstall的cdn链接-->
    <remote-js src="//res.cdn.openinstall.io/openinstall.js"></remote-js>

    <!--直播间-->
    <videoLive v-if="live_ready"></videoLive>

    <!--电台-->
    <videoVoice v-else-if="voice_ready" @open_reg="open_reg"></videoVoice>

    <!--照片动态-->
    <videoPhoto v-else-if="photo_ready" @open_reg="open_reg"></videoPhoto>

    <!--视频-->
    <videoV v-else-if="video_ready" :list="list" :v_info="video_info"></videoV>



    <!--底部列表-->
    <videoList :list="list"></videoList>

    <!--注册界面-->
    <div class="tc" v-if="show_reg_tc" @click="show_reg_tc = false">
      <!--登录方式-->
      <div
        class="login-type absoluteItem centerImg radius03rem"
        v-if="showLogin == 0"
        @click.stop
      >
        <p class="p1">请选择登录方式</p>
        <p class="p2 flex-box">
          <span @click="showLogin = 1">
            <img src="../../assets/share/vs(5).png" />
            <br />
            手机号
          </span>
          <span @click="loginWx" v-show="wxl">
            <img src="../../assets/share/vs(6).png" />
            <br />
            微信
          </span>
        </p>
      </div>

      <!--手机登录-->
      <div
        class="login login-phone absoluteItem centerImg whiteB radius05rem"
        @click.stop
        v-if="showLogin == 1"
      >
        <p class="phone_box">
          <input
            type="text"
            maxlength="11"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            placeholder="请输入手机号码"
            v-model="phone"
          />
        </p>
        <p class="pass_box">
          <input type="password" v-model="login_pass" placeholder="请输入密码" />
        </p>
        <span class="rg-tip"><i @click="showLogin = 2">没有账号？前往注册</i></span>  
        <span class="error" v-show="errormsg">{{ errmsg }}</span>
        <div class="relativeItem radius3" :class="{ rg_able: !login }" @click="login_fn">
          确定
        </div>
        <h3 class="absoluteItem centerX">登录</h3>
        <img
          src="../../assets/zhibotc.png"
          class="close-sign absoluteItem"
          @click="show_reg_tc = false"
        />
      </div>

      <!--手机注册-->
      <div
        class="login absoluteItem centerImg whiteB radius05rem"
        @click.stop
        v-if="showLogin == 2"
      >
        <p class="phone_box">
          <input
            type="text"
            maxlength="11"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            placeholder="请输入手机号码"
            v-model="phone"
          />
        </p>
        <p class="relativeItem flex-box">
          <input
            type="text"
            maxlength="6"
            placeholder="请输入图片验证码"
            v-model="imgcode"
          />
          <img :src="imgcodeurl" class="imgy" @click="getImgCode" />
        </p>
        <p class="relativeItem flex-box">
          <input
            type="text"
            maxlength="6"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            placeholder="请输入验证码"
            v-model="yzm"
          />
          <span :class="{ disable: !getCode }" @click="gcode">{{ codeText }}</span>
        </p>
        <p class="pass_box">
          <input type="password" v-model="pass" placeholder="请设置密码（不少于6位）" />
        </p>
        <span class="error" v-show="errormsg">{{ errmsg }}</span>
        <div class="relativeItem radius3" :class="{ rg_able: !rg }" @click="reg">
          注册并登录
        </div>
        <h3 class="absoluteItem centerX">手机注册</h3>
        <img
          src="../../assets/zhibotc.png"
          class="close-sign absoluteItem"
          @click="show_reg_tc = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
let Base64 = require("js-base64").Base64;
import videoList from "./video_list";
import videoV from "./video_v";
import videoLive from "./video_live";
import videoVoice from "./video_voice";
import videoPhoto from "./video_photo";

export default {
  name: "video_share",
  components: {
    videoList,
    videoV,
    videoLive,
    videoVoice,
    videoPhoto,
    "remote-js": {
      render(createElement) {
        return createElement("script", {
          attrs: { type: "text/javascript", src: this.src },
        });
      },
      props: {
        src: { type: String, required: true },
      },
    },
  },
  data() {
    return {
      voice_ready: false, //是否分享电台
      live_ready: false, //是否加载直播间播放器
      share_live: false, //判断是分享小视频还是直播间 true直播间 false小视频
      photo_ready:false,//判断是否分享的照片动态
      video_info: [],
      list: [],
      video_ready: false, //是否加载video播放器
      show_reg_tc: false, //是否显示注册界面
      rg: false,
      login: false,
      showLogin: 0, //0注册方式 1手机登录 2手机注册
      wxl: false, //判断是否在微信中
      phone: "",
      yzm: "",
      pass: "",
      login_pass: "", //登录用的密码
      imgcode: "", //图片验证码
      imgcodeurl: "",
      codeText: "获取验证码",
      getCode: false, //是否可以获取验证码
      errormsg: false,
      errmsg: "",
    };
  },
  updated() {
    document.querySelectorAll("input").forEach((item) => {
      item.onblur = this.temporaryRepair;
    });
  },
  methods: {
    /**请求视频信息接口 */
    get_video_info(id) {
      let _this = this;
      let data = {
        pagesize: 6,
        live_id: id || this.$route.query.live_id,
      };
      this.$jsonp(this.$apis("video_share_info"), data, (res) => {
        _this.video_info = res.data.data.data.info;
        _this.list = res.data.data.data.list;
        _this.video_ready = true;
      });
    },

    /**请求大厅热门开播接口 */
    get_hot() {
      let _this = this;
      let data = {
        pagesize: 6,
        page: 1,
      };
      this.$jsonp(this.$apis("home"), data, (res) => {
        let ls = res.data.data.result.hotToday;
        if (ls.length > 0) {
          ls.forEach((e) => {
            e.heat = _this.$tool.million(e.heat);
          });
        }
        _this.list = ls;
      });
    },

    /**打开注册界面 */
    open_reg() {
      //如果不是在微信中就直接打開手机注册界面
      this.show_reg_tc = true;
      this.showLogin = 0;
      // if (!this.wxl) this.showLogin = 1;
      this.getImgCode();
      //如果微信登录成功了就直接打开下载提示
      // if (window.location.href.indexOf("token") != -1) {
      //   this.$tool.download();
      // } else {
      //   this.show_reg_tc = true;
      // }
    },

    //微信登录
    loginWx() {
      if (this.$tool.inWX()) {
        //进行微信授权登录
        let l = window.location.href;
        l = Base64.encode(l);
        //如果连接上有uid 就传进去
        if (this.$tool.isStr(this.$route.query.uid)) {
          window.location.href =
            "http://oauth.fjkankan.com/index/Index/oauth.html?dourl=" +
            l +
            "&uid=" +
            this.$route.query.uid;
        } else if (this.$tool.isStr(this.$route.query.u)) {
          window.location.href =
            "http://oauth.fjkankan.com/index/Index/oauth.html?dourl=" +
            l +
            "&unid=" +
            this.$route.query.u;
        } else {
          window.location.href =
            "http://oauth.fjkankan.com/index/Index/oauth.html?dourl=" + l;
        }
      } else {
        alert("请在微信中打开");
      }
    },

    //检测微信是否登录成功
    loginWxF() {
      if (!this.$tool.inWX()) {
        if (window.location.href.indexOf("token") != -1) {
          let c = window.location.href.substring(
            window.location.href.indexOf("token"),
            window.location.href.length
          );
          let token = c.split("=")[1];
          this.$cookie.setC("token", token, 3);
          //刷新页面
          // if (!this.$tool.isStr(this.$cookie.getC("token"))) {
          //   window.location.reload();
          // }
          // this.$tool.download("download", "注册成功", "确定");
        } else {
          this.redBaoState = 0;
        }
      }
    },

    //获取验证码
    gcode() {
      if (this.getCode) {
        this.getCode = false;
      } else {
        return;
      }

      let _this = this;
      _this.errormsg = false;
      _this.errmsg = "";
      let data = {
        phone: this.phone,
        code: this.imgcode.toLowerCase(),
      };
      this.$jsonp(this.$apis("code"), data, (res) => {
        if (res.data.data.status == 200) {
          _this.$tool.tip("验证码已发送");
          //发送成功
          _this.getCode = false;
          let num = 59;
          let co = setInterval(() => {
            num--;
            _this.codeText = "已发送(" + num + ")";
            if (num == 0) {
              clearInterval(co);
              _this.codeText = "获取验证码";
              _this.getCode = true;
            }
          }, 1000);
        } else if (res.data.data.status == 201) {
          // 判断此账号已经存在就弹窗 老用户
          _this.show_reg_tc = false;
          _this.redBaoState = 2;
          _this.$tool.download("download", "此号码已注册", "确定");
        } else {
          //错误信息提示
          _this.errmsg = res.data.data.msg;
          _this.errormsg = true;
        }
      });
    },

    /**获取图片yzm */
    getImgCode() {
      let _this = this;
      _this.errormsg = false;
      this.$jsonp(this.$apis("imgcode"), {}, (res) => {
        if (res.data.data.status == 200) {
          _this.imgcodeurl = res.data.data.data;
        } else {
          //错误信息提示
          _this.errmsg = res.data.data.msg;
          _this.errormsg = true;
        }
      });
    },

    //手机注册
    reg() {
      if (this.rg) {
        this.rg = false;
      } else {
        return;
      }

      let _this = this;
      _this.errormsg = false;
      _this.errmsg = "";
      let data = {
        phone: this.phone,
        code: this.yzm,
        password: this.pass,
        uid: "0", //没有分享者的情况下
      };

      //如果链接上有userID就进行管理操作
      if (this.$tool.isStr(this.$route.query.uid)) {
        data.uid = this.$route.query.uid;
      } else if (this.$tool.isStr(this.$route.query.u)) {
        data.unid = this.$route.query.u;
      }

      this.$jsonp(this.$apis("rg"), data, (res) => {
        //注册成功,token存入cookie,刷新页面
        if (res.data.data.status == 200) {
          //新用户
          _this.show_reg_tc = false;
          _this.clear_content_reg();
          _this.$cookie.setC("token", res.data.data.token[0], 3);
          window.location.reload();
        } else {
          //错误信息提示
          _this.errmsg = res.data.data.msg;
          _this.errormsg = true;
        }
        _this.rg = true;
      });
    },

    //清空注册表的内容
    clear_content_reg() {
      this.phone = "";
      this.imgcode = "";
      this.pass = "";
      this.yzm = "";
      this.login_pass = "";
    },

    //注册表变化执行
    reg_change() {
      if (
        this.yzm.length == 6 &&
        this.$tool.checkPhone(this.phone) &&
        this.pass.length >= 6 &&
        this.imgcode != ""
      ) {
        this.rg = true;
      } else {
        this.rg = false;
      }
    },

    //登录表变化执行
    log_change() {
      if (this.$tool.checkPhone(this.phone) && this.login_pass.length >= 6) {
        this.login = true;
      } else {
        this.login = false;
      }
    },

    //手机登录
    login_fn() {
      if (this.login) {
        this.login = false;
      } else {
        return;
      }

      let _this = this;
      let data = {
        mobile: this.phone,
        password: this.login_pass,
      };

      //如果有推荐者就带上推荐者
      if (this.$tool.isStr(this.$route.query.uid)) {
        data.uid = this.$route.query.uid;
      } else if (this.$tool.isStr(this.$route.query.u)) {
        data.unid = this.$route.query.u;
      }

      this.$jsonp(this.$apis("phoneLogin"), data, (res) => {
        if (res.data.data.is_login) {
          //保存token在cookie
          _this.$cookie.setC("token", res.data.data.token[0], 3);
          window.location.reload();
        } else {
          //错误信息提示
          _this.errmsg = res.data.data.msg;
          _this.errormsg = true;
          _this.login = true;
        }
        
      });
    },
  },
  mounted: function () {
    this.loginWxF();
    //判断是直播间还是视频
    if (this.$route.query.share_bs) {
      //分享的电台
      this.voice_ready = true;
      this.get_hot();
    } else if (this.$route.query.share_live) {
      //分享的直播间
      this.share_live = true;
      this.live_ready = true;
      this.get_hot();
    } else if(this.$route.query.share_photo){
      //分享照片
      this.photo_ready = true;
      this.get_video_info();
    } else {
      //分享的视频
      if (!this.$route.query.live_id) {
        //直接跳到分享页
        this.$router.replace("/share");
      } else {
        //请求视频接口
        this.get_video_info();
      }
    }
  },
  watch: {
    showLogin(){
      this.clear_content_reg();
    },
    show_reg_tc() {
      if (!this.show_reg_tc) {
        //相应数据清空
        this.showLogin = 0;
        this.clear_content_reg();
      }
    },
    phone() {
      if (
        this.$tool.checkPhone(this.phone) &&
        this.imgcode != "" &&
        this.codeText == "获取验证码"
      ) {
        this.getCode = true;
      } else {
        this.getCode = false;
      }
      this.reg_change();
      this.log_change();
    },
    imgcode() {
      if (
        this.$tool.checkPhone(this.phone) &&
        this.imgcode != "" &&
        this.codeText == "获取验证码"
      ) {
        this.getCode = true;
      } else {
        this.getCode = false;
      }
    },
    yzm() {
      this.reg_change();
    },
    pass() {
      this.reg_change();
    },
    login_pass() {
      this.log_change();
    },
  },
};
</script>

<style scoped>
#video_share {
  min-height: 100vh;
  background: #fff;
}

.tc {
  z-index: 999999;
}
/**登录选择 */
.login-type,
.login {
  width: 80%;
  background: #fff;
  padding-top: 15px;
  transform-origin: left top;
  animation: showDownload 0.4s;
  -webkit-animation: showDownload 0.4s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.login-type .p1 {
  position: relative;
  text-align: center;
  font-size: 12px;
  color: #ccc;
}
.login-type .p1::after,
.login-type .p1::before {
  position: absolute;
  content: "";
  width: 20%;
  height: 1px;
  background: #ccc;
  top: 50%;
  transform: translateY(-50%) scale(0.8);
}
.login-type .p1::after {
  right: 10%;
}
.login-type .p1::before {
  left: 10%;
}
.login-type .p2 {
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-align: center;
  color: #666;
  margin: 17px 0;
}

.login-type .p2 span:nth-child(2) {
  margin-left: 20%;
}
.login-type .p2 img {
  width: 50px;
}

/*手机登录/注册*/
.login {
  padding: 1rem 0.8rem;
  padding-top: 50px;
}
.login h3 {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  top: 15px;
}
.login .close-sign {
  width: 15px;
  top: 18px;
  right: 16px;
}
.login p {
  padding: 0.6rem 0;
  padding-left: 2.2rem;
  margin-bottom: 12px;
  border-radius: 3rem;
}
.login p:first-child {
  background: url("../../assets/share/vs(4).png") no-repeat 0.5rem center #f5f5f5;
  background-size: 1.2rem;
}
.login p:nth-child(2) {
  background: url("../../assets/share/vs(2).png") no-repeat 0.5rem center #f5f5f5;
  background-size: 1.2rem;
}
.login p:nth-child(3) {
  background: url("../../assets/share/vs(1).png") no-repeat 0.5rem center #f5f5f5;
  background-size: 1.2rem;
  align-items: center;
}

.login p:nth-child(3) input,
.login p:nth-child(2) input {
  width: 55%;
}

.login p:nth-child(3) *,
.login p:nth-child(2) * {
  vertical-align: middle;
}
.login p:nth-child(4) {
  background: url("../../assets/share/vs(3).png") no-repeat 0.5rem center #f5f5f5;
  background-size: 1.2rem;
}
.login-phone p:nth-child(2) {
  background: url("../../assets/share/vs(3).png") no-repeat 0.5rem center #f5f5f5;
  background-size: 1.2rem;
}
.login a {
  background: rgba(255, 255, 255, 0.5);
}
.imgy {
  width: 33%;
  height: 30px;
}

input {
  font-size: 15px;
  background: #f5f5f5;
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #ccc;
}
.login p:nth-child(3) span {
  display: inline-block;
  width: 40%;
  text-align: center;
  font-size: 12px;
  color: #c471f5;
}
.login p:nth-child(3) .disable {
  color: #ccc;
}
.login .error {
  font-size: 12px;
  color: red;
}
.login-phone .rg-tip{
  display: block;
  text-align: right;
}
.login-phone .rg-tip i{
  font-style: normal;
    font-size: 12px;
  color: #9701ff;
}
.login div {
  background: -webkit-linear-gradient(left, #f20fff, #9701ff);
  background: linear-gradient(to right, #f20fff, #9701ff);
  font-size: 15px;
  color: #fff;
  width: 85%;
  margin: 0 auto;
  margin-top: 1.5rem;
  padding: 0.7rem 0;
  text-align: center;
}
.login .rg_able {
  background: #999;
}
</style>
